import { RouteName } from "@/User/Constants/routes";
import route from "ziggy-js";

export const MessageComponentPrefix = 'Message';

export const MessageListComponent = 'Message/index';
export const MessageDetailComponent = 'Message/show';

export const generateMessageBreadcrumbs = ({ component }) => {
    let breadcrumbs = [
        {
            label: 'メッセージ一覧',
            url: route(RouteName.MyMessagePage),
        }
    ];

    if (component === MessageDetailComponent) {
        breadcrumbs = [
            ...breadcrumbs,
            {
                label: 'メッセージ詳細',
                url: '',
            }
        ];
    }

    return breadcrumbs;
};
